/* eslint-disable react/no-danger */
import React from 'react';
import { useSelector } from 'react-redux';

import DOMPurify from 'isomorphic-dompurify';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink/ExternalLink';
import { WizardStep } from '@/components/Wizard';
import { CONTACT_US_URL } from '@/constants';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';
import { selectResources } from '@/reducers/common/selectors';

import styles from './ClaimBookingStep.module.scss';

type ClaimImportingInProgressProps = {
  tabId: string;
  reloadReservation: () => void;
};

const ClaimImportingInProgress: React.FC<ClaimImportingInProgressProps> = ({ tabId, reloadReservation }) => {
  const appUiData = useAppUiData();
  const resources = useSelector(selectResources);
  return (
    <WizardStep tabId={tabId}>
      <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.title]}</h2>
      <p className={styles.subtitleMain}>{appUiData[appUiIds.importation.importing]}</p>
      <p
        className={styles.subtitle}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appUiData[appUiIds.importation.tryReloadingText]) }}
      />
      <Button variant="primary" onClick={reloadReservation} className={styles.buttonReloadReservation}>
        {appUiData[appUiIds.importation.reloadReservation]}
      </Button>
      <div className={styles.linkContainer}>
        <ExternalLink href={resources[CONTACT_US_URL] as string} name={appUiData[appUiIds.sailorServices]} />
      </div>
    </WizardStep>
  );
};

export default ClaimImportingInProgress;
